import Elemento from "./Elemento.js";

export default class Option extends Elemento {
    constructor() {
        super();
    }
}